import { type AnalyticsEvent } from '@backstage/core-plugin-api';
import { type MetricRequest } from '@internal/plugin-neo4j-analytics-common';

import { BASE_METRIC_NAME } from '../const';

export interface AnalyticsEventHandler {
  readonly eventName: string;
  readonly metricName: string;
  canHandle(action: string): boolean;

  // Transform an analytics event to metric requests
  handle(event: AnalyticsEvent): MetricRequest[];
}

export abstract class BaseAnalyticsEventHandler implements AnalyticsEventHandler {
  protected readonly baseMetricName: string;
  protected readonly sentinelMissingValue = 'unknown';

  constructor(baseMetricName: string = BASE_METRIC_NAME) {
    this.baseMetricName = baseMetricName;
  }

  abstract eventName: string;
  abstract metricName: string;
  abstract canHandle(action: string): boolean;
  abstract handle(event: AnalyticsEvent): MetricRequest[];

  protected getMetricName(action: string): string {
    return `${this.baseMetricName}.${action}`;
  }
}
